<template>
  <div
    :class="$style.container"
  >
    <hr
      v-if="!item.isBookmark"
      :class="$style.hr"
    >
    <ApplicationSSOStatus
      v-if="!item.isBookmark"
      :commitHasFailed="commitHasFailed"
      :handleError="handleError"
    />
    <hr :class="$style.hr">
    <ApplicationSCIMStatus />
    <hr
      v-if="$hasFeatureFlag($featureFlags.ssoHiddenApps)"
      :class="$style.hr"
    >
    <li
      v-if="$hasFeatureFlag($featureFlags.ssoHiddenApps)"
      :class="[$style.statusItem, $style.statusHiddenApp]"
    >
      <header :class="$style.header">
        User Portal Visibility
      </header>
      <Icon
        :class="$style.statusHiddenAppIcon"
        :icon="iconName"
        :scale="1"
      />
      <label
        v-if="ssoHidden"
      >
        Hidden in user portal
      </label>
      <label
        v-if="!ssoHidden"
      >
        Visible in user portal
      </label>
    </li>
  </div>
</template>
<script>
import { Icon } from '@jumpcloud/ui-components';
import { StoreModelMap } from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import ApplicationSCIMStatus from 'client/applications/ApplicationSCIMStatus';
import ApplicationSSOStatus from 'client/applications/ApplicationSSOStatus';
import ItemTypeConstants from 'client/util/Constants/ItemTypeConstants';

const { ItemTypeConsts } = ItemTypeConstants;
const { application } = ItemTypeConsts;
const applicationModel = StoreModelMap[application];

export default {
  name: 'ApplicationStatus',

  components: {
    ApplicationSCIMStatus,
    ApplicationSSOStatus,
    Icon,
  },

  props: {
    commitHasFailed: {
      type: Boolean,
      default: false,
    },
    handleError: {
      type: Function,
      required: true,
    },
  },

  computed: {
    ...mapState(applicationModel, [
      'item',
    ]),
    ...mapGetters(applicationModel, [
      'isItemBeingCreated',
      'ssoHidden',
    ]),
    iconName() {
      return this.ssoHidden ? 'viewableOff' : 'viewable';
    },
  },
};
</script>

<style module>
.container {
  min-width: 160px;
}

.header {
  font-size: 16px;
  font-weight: 800;
}

.hr {
  border: 0;
  border-bottom: var(--jc-border-width) solid var(--jc-border-color-medium);
  margin: var(--jc-spacer) 0;
}

.statusItem {
  list-style-type: none;
}

.statusHiddenApp {
  font-size: 1.1rem;
  font-weight: 600;
}

.statusHiddenAppIcon {
  margin-right: 3px;
  margin-top: 20px;
}
</style>
